/*
 * Copyright (c) 2020.  Sanish Manandhar
 * All Rights Reserved
 */

export const TASK_TEMPLATE_CLEAN_REQUEST = 'TASK_TEMPLATE_CLEAN_REQUEST';

export const TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST = 'TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST';
export const TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS =
  'TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS';
export const TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE =
  'TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE';

export const TASK_TEMPLATE_FETCH_REQUEST = 'TASK_TEMPLATE_FETCH_REQUEST';
export const TASK_TEMPLATE_FETCH_REQUEST_SUCCESS = 'TASK_TEMPLATE_FETCH_REQUEST_SUCCESS';
export const TASK_TEMPLATE_FETCH_REQUEST_FAILURE = 'TASK_TEMPLATE_FETCH_REQUEST_FAILURE';

export const TASK_TEMPLATE_UPSERT_REQUEST = 'TASK_TEMPLATE_UPSERT_REQUEST';
export const TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS = 'TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS';
export const TASK_TEMPLATE_UPSERT_REQUEST_FAILURE = 'TASK_TEMPLATE_UPSERT_REQUEST_FAILURE';

export const TASK_TEMPLATE_DELETE_REQUEST = 'TASK_TEMPLATE_DELETE_REQUEST';
export const TASK_TEMPLATE_DELETE_REQUEST_SUCCESS = 'TASK_TEMPLATE_DELETE_REQUEST_SUCCESS';
export const TASK_TEMPLATE_DELETE_REQUEST_FAILURE = 'TASK_TEMPLATE_DELETE_REQUEST_FAILURE';

export const SUB_TASK_TEMPLATE_UPSERT_REQUEST = 'SUB_TASK_TEMPLATE_UPSERT_REQUEST';
export const SUB_TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS = 'SUB_TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS';
export const SUB_TASK_TEMPLATE_UPSERT_REQUEST_FAILURE = 'SUB_TASK_TEMPLATE_UPSERT_REQUEST_FAILURE';

export const SUB_TASK_TEMPLATE_DELETE_REQUEST = 'SUB_TASK_TEMPLATE_DELETE_REQUEST';
export const SUB_TASK_TEMPLATE_DELETE_REQUEST_SUCCESS = 'SUB_TASK_TEMPLATE_DELETE_REQUEST_SUCCESS';
export const SUB_TASK_TEMPLATE_DELETE_REQUEST_FAILURE = 'SUB_TASK_TEMPLATE_DELETE_REQUEST_FAILURE';

export const SUB_TASK_INDEX_STORE_REQUEST = 'SUB_TASK_INDEX_STORE_REQUEST';
export const SUB_TASK_INDEX_STORE_REQUEST_SUCCESS = 'SUB_TASK_INDEX_STORE_REQUEST_SUCCESS';
export const SUB_TASK_INDEX_STORE_REQUEST_FAILURE = 'SUB_TASK_INDEX_STORE_REQUEST_FAILURE';

export const SUB_TASK_TEMPLATE_FETCH_REQUEST = 'SUB_TASK_TEMPLATE_FETCH_REQUEST';
export const SUB_TASK_TEMPLATE_FETCH_REQUEST_SUCCESS = 'SUB_TASK_TEMPLATE_FETCH_REQUEST_SUCCESS';
export const SUB_TASK_TEMPLATE_FETCH_REQUEST_FAILURE = 'SUB_TASK_TEMPLATE_FETCH_REQUEST_FAILURE';
